import React from 'react';
import {Downloads} from '@epic-ui/icons';
import Button, {ButtonProps} from './Button';

export type DownloadButtonProps = ButtonProps;

const DownloadButton: React.FC<DownloadButtonProps> = ({children, ...rest}) => {
    return (
        <Button startIcon={<Downloads />} download {...rest}>
            {children}
        </Button>
    );
};

export default DownloadButton;
